import { render, staticRenderFns } from "./ExwarehouseAdd.vue?vue&type=template&id=60eb67ca&scoped=true"
import script from "./ExwarehouseAdd.vue?vue&type=script&lang=js"
export * from "./ExwarehouseAdd.vue?vue&type=script&lang=js"
import style0 from "./ExwarehouseAdd.vue?vue&type=style&index=0&id=60eb67ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eb67ca",
  null
  
)

export default component.exports